import React, {useState, useEffect, useContext, useRef } from 'react';
import { IonModal, IonGrid, IonRow, IonCol, IonButton, IonSlides, IonSlide, IonContent, IonHeader, IonInput, IonLabel, IonText, IonFooter, IonCheckbox } from '@ionic/react';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import { ViewInvoiceModal } from './Modal_ViewInvoice';

import '../../../css/layout.css';




export function Onboarding_Details(props) {


    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    let [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [viewApplicationDetails, setViewApplicatioDetails] = useState([]);

    const [companyRole, setCompanyRole] = useState(null);
    const [companyAccessRole, setCompanyAccessRole] = useState(null);
    const [jobRequisitionName, setJobRequisitionName] = useState(null);
    const [employeeFirstName, setEmployeeFirstName] = useState(null);
    const [employeeMiddleName, setEmployeeMiddleName] = useState(null);
    const [employeeLastName, setEmployeeLastName] = useState(null);
    const [employeePhoneNumber, setEmployeePhoneNumber] = useState(null);
    const [employeeEmail, setEmployeeEmail] = useState(null);
    const [employeeAddressNumber, setEmployeeAddressNumber] = useState(null);
    const [employeeStreetName, setEmployeeStreetName] = useState(null);
    const [employeeCity, setEmployeeCity] = useState(null);
    const [employeeCityDistrict, setEmployeeCityDistrict] = useState(null);
    const [employeeCountryRegion, setEmployeeCountryRegion] = useState(null);
    const [employeeCountry, setEmployeeCountry] = useState(null);
    const [employeeDigitalAddressID, setEmployeeDigitalAddressID] = useState(null);
    const [applicantResume, setApplicantResume] = useState(null);
    
    const [offer_status, setOffer_status] = useState(null);
    const [offer_date, setOffer_date] = useState(null);
    const [offer_amount, setOffer_amount] = useState(null);
    const [offer_document, setOffer_document] = useState(null);
    
    const [employeeUpload_ghanaID, setEmployeeUpload_ghanaID] = useState(null);
    const [employeeUpload_verifyMTNMomo, setEmployeeUpload_verifyMTNMomo] = useState(null);
    const [employeeUpload_utilityBill, setEmployeeUpload_utilityBill] = useState(null);
    const [employeeUsername, setEmployeeUsername] = useState(null);
    const [employeePassword, setEmployeePassword] = useState(null);
    const [employeeCompanyAccessRole, setEmployeeCompanyAccessRole] = useState(null);
    const [employeeHireDate, setEmployeeHireDate] = useState(new Date());

    const [onboardingDateLogged, setOnboardingDateLogged] = useState(null);
    const [onboarding_staus_initial, setOnboarding_staus_initial] = useState(null);
    const [onboarding_staus, setOnboarding_staus] = useState(null);


    let [viewGhanaIDModal, setViewGhanaIDModal] = useState(false);
    let [viewUtilityBillModal, setViewUtilityBillModal] = useState(false);


    let [employeeFirstName_checked, setEmployeeFirstName_checked] = useState(false);
    let [employeeMiddleName_checked, setEmployeeMiddleName_checked] = useState(false);
    let [employeeLastName_checked, setEmployeeLastName_checked] = useState(false);
    let [employeePhoneNumber_checked, setEmployeePhoneNumber_checked] = useState(false);
    let [employeeEmail_checked, setEmployeeEmail_checked] = useState(false);
    let [employeeAddressNumber_checked, setEmployeeAddressNumber_checked] = useState(false);
    let [employeeStreetName_checked, setEmployeeStreetName_checked] = useState(false);
    let [employeeCity_checked, setEmployeeCity_checked] = useState(false);
    let [employeeCityDistrict_checked, setEmployeeCityDistrict_checked] = useState(false);
    let [employeeCountryRegion_checked, setEmployeeCountryRegion_checked] = useState(false);
    let [employeeCountry_checked, setEmployeeCountry_checked] = useState(false);
    let [employeeDigitalAddressID_checked, setEmployeeDigitalAddressID_checked] = useState(false);
    let [employeeUpload_ghanaID_checked, setEmployeeUpload_ghanaID_checked] = useState(false);
    let [employeeUpload_verifyMTNMomo_checked, setEmployeeUpload_verifyMTNMomo_checked] = useState(false);
    let [employeeUpload_utilityBill_checked, setEmployeeUpload_utilityBill_checked] = useState(false);
    let [employeeUsername_checked, setEmployeeUsername_checked] = useState(false);
    let [employeePassword_checked, setEmployeePassword_checked] = useState(false);
    let [employeeCompanyAccessRole_checked, setEmployeeCompanyAccessRole_checked] = useState(false);
    let [employeeHireDate_checked, setEmployeeHireDate_checked] = useState(false);
    
    let [offer_status_checked, setOffer_status_checked] = useState(false);
    let [offer_date_checked, setOffer_date_checked] = useState(false);
    let [offer_amount_checked, setOffer_amount_checked] = useState(false);
    let [offer_document_checked, setOffer_document_checked] = useState(false);
    
    let [jobRequisitionName_checked, setJobRequisitionName_checked] = useState(false);
    let [companyRole_checked, setCompanyRole_checked] = useState(false);
    let [companyAccessRole_checked, setCompanyAccessRole_checked] = useState(false);
    let [onboardingDateLogged_checked, setOnboardingDateLogged_checked] = useState(false);
    let [onboardingStatus_checked, setOnboarding_staus_checked] = useState(false);
    let [applicantResume_checked, setApplicantResume_checked] = useState(false);


    let [employeeFirstName_checked_data, setEmployeeFirstName_checked_data] = useState(null);
    let [employeeMiddleName_checked_data, setEmployeeMiddleName_checked_data] = useState(null);
    let [employeeLastName_checked_data, setEmployeeLastName_checked_data] = useState(null);
    let [employeePhoneNumber_checked_data, setEmployeePhoneNumber_checked_data] = useState(null);
    let [employeeEmail_checked_data, setEmployeeEmail_checked_data] = useState(null);
    let [employeeAddressNumber_checked_data, setEmployeeAddressNumber_checked_data] = useState(null);
    let [employeeStreetName_checked_data, setEmployeeStreetName_checked_data] = useState(null);
    let [employeeCity_checked_data, setEmployeeCity_checked_data] = useState(null);
    let [employeeCityDistrict_checked_data, setEmployeeCityDistrict_checked_data] = useState(null);
    let [employeeCountryRegion_checked_data, setEmployeeCountryRegion_checked_data] = useState(null);
    let [employeeCountry_checked_data, setEmployeeCountry_checked_data] = useState(null);
    let [employeeDigitalAddressID_checked_data, setEmployeeDigitalAddressID_checked_data] = useState(null);
    let [employeeUpload_ghanaID_checked_data, setEmployeeUpload_ghanaID_checked_data] = useState(null);
    let [employeeUpload_verifyMTNMomo_checked_data, setEmployeeUpload_verifyMTNMomo_checked_data] = useState(null);
    let [employeeUpload_utilityBill_checked_data, setEmployeeUpload_utilityBill_checked_data] = useState(null);
    let [employeeUsername_checked_data, setEmployeeUsername_checked_data] = useState(null);
    let [employeePassword_checked_data, setEmployeePassword_checked_data] = useState(null);
    let [employeeCompanyAccessRole_checked_data, setEmployeeCompanyAccessRole_checked_data] = useState(null);
    let [employeeHireDate_checked_data, setEmployeeHireDate_checked_data] = useState(new Date());

    let [offer_status_checked_data, setOffer_status_checked_data] = useState(false);
    let [offer_date_checked_data, setOffer_date_checked_data] = useState(false);
    let [offer_amount_checked_data, setOffer_amount_checked_data] = useState(false);
    let [offer_document_checked_data, setOffer_document_checked_data] = useState(false);
    
    let [jobRequisitionName_checked_data, setJobRequisitionName_checked_data] = useState(false);
    let [companyRole_checked_data, setCompanyRole_checked_data] = useState(false);
    let [companyAccessRole_checked_data, setCompanyAccessRole_checked_data] = useState(false);
    let [onboardingDateLogged_checked_data, setOnboardingDateLogged_checked_data] = useState(false);
    let [onboardingStatus_checked_data, setOnboarding_staus_checked_data] = useState(false);
    let [applicantResume_checked_data, setApplicantResume_checked_data] = useState(null);

    let [row_1, setRow_1] = useState(false);
    let [row_2, setRow_2] = useState(false);
    let [row_3, setRow_3] = useState(false);
    let [row_4, setRow_4] = useState(false);
    let [row_5, setRow_5] = useState(false);
    let [row_6, setRow_6] = useState(false);
    let [row_7, setRow_7] = useState(false);
    let [row_8, setRow_8] = useState(false);
    let [row_9, setRow_9] = useState(false);
    let [row_10, setRow_10] = useState(false);
    let [row_11, setRow_11] = useState(false);
    let [row_12, setRow_12] = useState(false);
    let [row_13, setRow_13] = useState(false);
    let [row_14, setRow_14] = useState(false);
    let [row_15, setRow_15] = useState(false);
    let [row_16, setRow_16] = useState(false);
    let [row_17, setRow_17] = useState(false);



    useEffect(() => {   


        let accountID;
        
        if(props.data.status == 'user_applicant_onboarding')
        {
            accountID = props.data.applicant_merchant_accountID
        }
        else
        {
            accountID = acctID;

        }

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: "74503_onboarding_details",
                user: accountID,
                xJobRequisitionID: props.data.requisitionID,
                xJobApplicationID: props.data.applicationID,
                sessionID: sessionID,

            }),
        }
        let url;

        if(props.data.status == 'user_applicant_onboarding')
        {
           url = baseURL+'ghanaverified/';
        }
        else
        {
            url = baseURL+'internal_merchantAcct_argsjqApp'
        }
        
        fetch(url, requestOptions)
        .then(res => res.text())
        .then(res => {

            alert(res);

            let rows = res.toString().split('~~~');

            //for (let rownum = 0; rownum < rows.length - 1; ++rownum)
            //{
                let cols = rows[0].split('|');

                setJobRequisitionName(cols[2]);
                setCompanyRole(cols[3]);
                setEmployeeFirstName(cols[4]);
                setEmployeeMiddleName(cols[5]);
                setEmployeeLastName(cols[6]);
                setEmployeePhoneNumber(cols[7]);
                setEmployeeEmail(cols[8]);
                setEmployeeAddressNumber(cols[9]);
                setEmployeeStreetName(cols[10]);
                setEmployeeCity(cols[11]);
                setEmployeeCityDistrict(cols[12]);
                setEmployeeCountryRegion(cols[13]);
                setEmployeeCountry(cols[14]);
                setEmployeeDigitalAddressID(cols[15]);
                setApplicantResume(cols[16]);
                setOnboardingDateLogged(cols[17]);
                setOnboarding_staus(cols[18]);
                    setOnboarding_staus_initial(cols[18]);
                setOffer_date(cols[19]);
                setOffer_amount(cols[20]);
                setOffer_document(cols[21]);
                setEmployeeUpload_ghanaID(cols[22]);
                setEmployeeUpload_verifyMTNMomo(cols[23]);
                setEmployeeUpload_utilityBill(cols[24]);
                setEmployeeUsername(cols[25]);
                setEmployeePassword(cols[26]);
                setEmployeeCompanyAccessRole(cols[27]);

                // alert(cols[28]);
                // alert(cols[28].toString());
                // alert(new Date(cols[28]).toISOString().substr(0, 10));

                //setEmployeeHireDate(new Date(cols[28]));
                if (cols[28] !== "" && cols[28] !== "NULL") setEmployeeHireDate(new Date(cols[28]));

                setSchemaName(cols[29]);
                //setAcctID(props.data.applicant_merchant_accountID);

                setViewApplicatioDetails((prevViewRequisitionList) => {
                    return prevViewRequisitionList.concat({
                        requisition_id: cols[0], 
                        application_id: cols[1], 
                        requisition_name: cols[2], 
                        company_role: cols[3], 
                        applicant_first_name: cols[4], 
                        applicant_middle_name: cols[5], 
                        applicant_last_name: cols[6], 
                        applicant_phone_number: cols[7], 
                        applicant_email_address: cols[8], 
                        applicant_address_number: cols[9], 
                        applicant_street_name: cols[10], 
                        applicant_city: cols[11], 
                        applicant_city_district: cols[12], 
                        applicant_country_region: cols[13], 
                        applicant_country: cols[14], 
                        applicant_digital_address: cols[15], 
                        attachment_resume: cols[16], 
                        date_recieved: cols[17], 
                        application_status: cols[18],
                        offer_date: cols[19],
                        offer_amount: cols[20],
                        offer_document: cols[21],
                        upload_ghana_id: cols[22],
                        verify_mtn_momo: cols[23],
                        upload_utility_bill: cols[24],
                        username: cols[25],
                        password: cols[26],
                        company_access_role: cols[27],
                        //hire_date:  new Date(cols[28]).toISOString().substr(0, 10),

                        
                    })
                });
            //} 

                let cols2 = rows[1].split('|');

                setJobRequisitionName_checked_data(cols2[2]);
                setCompanyRole_checked_data(cols2[3]);
                setEmployeeFirstName_checked_data(cols2[4]);
                setEmployeeMiddleName_checked_data(cols2[5]);
                setEmployeeLastName_checked_data(cols2[6]);
                setEmployeePhoneNumber_checked_data(cols2[7]);
                setEmployeeEmail_checked_data(cols2[8]);
                setEmployeeAddressNumber_checked_data(cols2[9]);
                setEmployeeStreetName_checked_data(cols2[10]);
                setEmployeeCity_checked_data(cols2[11]);
                setEmployeeCityDistrict_checked_data(cols2[12]);
                setEmployeeCountryRegion_checked_data(cols2[13]);
                setEmployeeCountry_checked_data(cols2[14]);
                setEmployeeDigitalAddressID_checked_data(cols2[15]);
                setApplicantResume_checked_data(cols2[16]);
                setOnboardingDateLogged_checked_data(cols2[17]);
                setOnboarding_staus_checked_data(cols2[18]);
                setOffer_date_checked_data(cols2[19]);
                setOffer_amount_checked_data(cols2[20]);
                setOffer_document_checked_data(cols2[21]);
                setEmployeeUpload_ghanaID_checked_data(cols2[22]);
                setEmployeeUpload_verifyMTNMomo_checked_data(cols2[23]);
                setEmployeeUpload_utilityBill_checked_data(cols2[24]);
                setEmployeeUsername_checked_data(cols[25]);
                setEmployeePassword_checked_data(cols[26]);
                setEmployeeCompanyAccessRole_checked_data(cols[27]);
                setEmployeeHireDate_checked_data(cols[28]);

                if (cols2[2] !== "" && cols2[2] !== "NULL") setJobRequisitionName_checked(true);
                if (cols2[3] !== "" && cols2[3] !== "NULL") setCompanyRole_checked(true);
                if (cols2[4] !== "" && cols2[4] !== "NULL") setEmployeeFirstName_checked(true);
                if (cols2[5] !== "" && cols2[5] !== "NULL") setEmployeeMiddleName_checked(true);
                if (cols2[6] !== "" && cols2[6] !== "NULL") setEmployeeLastName_checked(true);
                if (cols2[7] !== "" && cols2[7] !== "NULL") setEmployeePhoneNumber_checked(true);
                if (cols2[8] !== "" && cols2[8] !== "NULL") setEmployeeEmail_checked(true);
                if (cols2[9] !== "" && cols2[9] !== "NULL") setEmployeeAddressNumber_checked(true);
                if (cols2[10] !== "" && cols2[10] !== "NULL") setEmployeeStreetName_checked(true);
                if (cols2[11] !== "" && cols2[11] !== "NULL") setEmployeeCity_checked(true);
                if (cols2[12] !== "" && cols2[12] !== "NULL") setEmployeeCityDistrict_checked(true);
                if (cols2[13] !== "" && cols2[13] !== "NULL") setEmployeeCountryRegion_checked(true);
                if (cols2[14] !== "" && cols2[14] !== "NULL") setEmployeeCountry_checked(true);
                if (cols2[15] !== "" && cols2[15] !== "NULL") setEmployeeDigitalAddressID_checked(true);
                if (cols2[16] !== "" && cols2[16] !== "NULL") setApplicantResume_checked(true);
                if (cols2[17] !== "" && cols2[17] !== "NULL") setOnboardingDateLogged_checked(true);
                if (cols2[18] !== "" && cols2[18] !== "NULL") setOnboarding_staus_checked(true);
                if (cols2[19] !== "" && cols2[19] !== "NULL") setOffer_date_checked(true);
                if (cols2[20] !== "" && cols2[20] !== "NULL") setOffer_amount_checked(true);
                if (cols2[21] !== "" && cols2[21] !== "NULL") setOffer_document_checked(true);
                if (cols2[22] !== "" && cols2[22] !== "NULL") setEmployeeUpload_ghanaID_checked(true);
                if (cols2[23] !== "" && cols2[23] !== "NULL") setEmployeeUpload_verifyMTNMomo_checked(true);
                if (cols2[24] !== "" && cols2[24] !== "NULL") setEmployeeUpload_utilityBill_checked(true);
                if (cols2[25] !== "" && cols2[25] !== "NULL") setEmployeeUsername_checked(true);
                if (cols2[26] !== "" && cols2[26] !== "NULL") setEmployeePassword_checked(true);
                if (cols2[27] !== "" && cols2[27] !== "NULL") setEmployeeCompanyAccessRole_checked(true);
                if (cols2[28] !== "" && cols2[28] !== "NULL") setEmployeeHireDate_checked(true);

                if(props.data.status == 'user_applicant_onboarding')
                {
                    setAcctID(props.data.applicant_merchant_accountID);
                }
                // setViewApplicatioDetails((prevViewRequisitionList) => {
                //     return prevViewRequisitionList.concat({
                //         requisition_id_checked_data: cols2[2], 
                //         application_id_checked_data: cols2[3], 
                //         requisition_name_checked_data: cols2[4], 
                //         company_role_checked_data: cols2[5], 
                //         applicant_first_name_checked_data: cols2[6], 
                //         applicant_middle_name_checked_data: cols2[7], 
                //         applicant_last_name_checked_data: cols2[8], 
                //         applicant_phone_number_checked_data: cols2[9], 
                //         applicant_email_address_checked_data: cols2[10], 
                //         applicant_address_number_checked_data: cols2[11], 
                //         applicant_street_name_checked_data: cols2[12], 
                //         applicant_city_checked_data: cols2[13], 
                //         applicant_city_district_checked_data: cols2[14], 
                //         applicant_country_region_checked_data: cols2[15], 
                //         applicant_country_checked_data: cols2[16], 
                //         applicant_digital_address_checked_data: cols2[17], 
                //         attachment_resume_checked_data: cols2[18], 
                //         date_recieved_checked_data: cols2[19], 
                //         application_status_checked_data: cols2[20],
                //         offer_date_checked_data: cols2[21],
                //         offer_amount_checked_data: cols2[22],
                //         offer_document_checked_data: cols2[23],
                //         upload_ghana_id_checked_data: cols2[24],
                //         verify_mtn_momo_checked_data: cols2[25],
                //         upload_utility_bill_checked_data: cols2[26],
                //     })
                // });

        })

    }, [])   



    function updateOnboardingStatus()
    {
        
        let formData = new FormData();
        formData.append('Tracker', '74503_onboarding_status_update');
        formData.append('props', props.data.status);
        formData.append('user', acctID);
        formData.append('schemaName', schema);
        formData.append('xJobRequisitionID', props.data.requisitionID);
        formData.append('xJobApplicationID', props.data.applicationID);
        formData.append('xEmployeeJobFunction', companyRole);
        formData.append('xJobRequisitionName', props.data.requisitionName);
        formData.append('xEmployeeFirstName', employeeFirstName);
        formData.append('xEmployeeMiddleName', employeeMiddleName);
        formData.append('xEmployeeLastName', employeeLastName);
        formData.append('xEmployeePhoneNumber', employeePhoneNumber);
        formData.append('xEmployeeEmailAddress', employeeEmail);
        formData.append('xEmployeeAddressNumber', employeeAddressNumber);
        formData.append('xEmployeeStreetName', employeeStreetName);
        formData.append('xEmployeeCity', employeeCity);
        formData.append('xEmployeeCityDistrict', employeeCityDistrict);
        formData.append('xEmployeeCountryRegion', employeeCountryRegion);
        formData.append('xEmployeeCountry', employeeCountry);
        formData.append('xEmployeeDigitalAddressID', employeeDigitalAddressID);
        formData.append('xResume', applicantResume);
        formData.append('xOnboardingStatus', onboarding_staus);


        formData.append('xOffer_status', offer_status);
        formData.append('xOffer_date', offer_date);
        formData.append('xOffer_amount', offer_amount);
        formData.append('xOffer_document', offer_document);

        formData.append('xEmployeeUpload_ghanaID', employeeUpload_ghanaID);
        formData.append('xEmployeeUpload_verifyMTNMomo', employeeUpload_verifyMTNMomo);
        formData.append('xEmployeeUpload_utilityBill', employeeUpload_utilityBill);
        formData.append('xInitialEmployeeUsername', employeeUsername);
        formData.append('xInitialEmployeePassword', employeePassword);
        formData.append('xEmployeeCompanyAccessRole', employeeCompanyAccessRole);
        formData.append('xEmployeeHireDate', employeeHireDate);


        // Adding _checked_data to the second values
        formData.append('xEmployeeCompanyAccessRole_checked_data', employeeCompanyAccessRole_checked_data);
        formData.append('xEmployeeJobFunction_checked_data', companyRole_checked_data);
        formData.append('xJobRequisitionName_checked_data', props.data.requisitionName_checked_data);
        formData.append('xEmployeeFirstName_checked_data', employeeFirstName_checked_data);
        formData.append('xEmployeeMiddleName_checked_data', employeeMiddleName_checked_data);
        formData.append('xEmployeeLastName_checked_data', employeeLastName_checked_data);
        formData.append('xEmployeePhoneNumber_checked_data', employeePhoneNumber_checked_data);
        formData.append('xEmployeeEmailAddress_checked_data', employeeEmail_checked_data);
        formData.append('xEmployeeAddressNumber_checked_data', employeeAddressNumber_checked_data);
        formData.append('xEmployeeStreetName_checked_data', employeeStreetName_checked_data);
        formData.append('xEmployeeCity_checked_data', employeeCity_checked_data);
        formData.append('xEmployeeCityDistrict_checked_data', employeeCityDistrict_checked_data);
        formData.append('xEmployeeCountryRegion_checked_data', employeeCountryRegion_checked_data);
        formData.append('xEmployeeCountry_checked_data', employeeCountry_checked_data);
        formData.append('xEmployeeDigitalAddressID_checked_data', employeeDigitalAddressID_checked_data);
        //formData.append('xResume_checked_data', applicantResume_checked_data);

        formData.append('xOffer_status_checked_data', offer_status_checked_data);
        formData.append('xOffer_date_checked_data', offer_date_checked_data);
        formData.append('xOffer_amount_checked_data', offer_amount_checked_data);
        //formData.append('xOffer_document_checked_data', offer_document_checked_data);

        //formData.append('xEmployeeUpload_ghanaID_checked_data', employeeUpload_ghanaID_checked_data);
        //formData.append('xEmployeeUpload_verifyMTNMomo_checked_data', employeeUpload_verifyMTNMomo_checked_data);
        //formData.append('xEmployeeUpload_utilityBill_checked_data', employeeUpload_utilityBill_checked_data);
        formData.append('xInitialEmployeeUsername_checked_data', employeeUsername_checked_data);
        formData.append('xInitialEmployeePassword_checked_data', employeePassword_checked_data);
        formData.append('xEmployeeCompanyAccessRole_checked_data', employeeCompanyAccessRole_checked_data);
        formData.append('xEmployeeHireDate_checked_data', employeeHireDate_checked_data);

        formData.append('sessionID', sessionID);


        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }

        let url;

        if(props.data.status == 'user_applicant_onboarding')
        {
           url = baseURL+'ghanaverified/';
        }
        else
        {
            url = baseURL+'internal_merchantAcct_argsjqApp'
        }
        
        fetch(url, requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);
            
            props.closeModal(false);

        })
        .catch(error => {
            console.error(error);
        })
    }

    function convertApplicantToEmployee()
    {
        let formData = new FormData();
        formData.append('Tracker', '74503_convert_applicantToEmployee');
        formData.append('user', acctID);
        formData.append('xJobRequisitionID', props.data.requisitionID);
        formData.append('xJobApplicationID', props.data.applicationID);
        formData.append('xEmployeeCompanyAccessRole', employeeCompanyAccessRole);
        formData.append('xEmployeeHireDate', employeeHireDate);
        formData.append('sessionID', sessionID);


        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        
        let url;

        if(props.data.status == 'user_applicant_onboarding')
        {
           url = baseURL+'ghanaverified/';
        }
        else
        {
            url = baseURL+'internal_merchantAcct_argsjqApp'
        }
        
        fetch(url, requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);
            
            props.closeModal(false);

        })
        .catch(error => {
            console.error(error);
        })
    }

    function recindOffer()
    {
        let formData = new FormData();
        formData.append('Tracker', '74503_recind_offer');
        formData.append('user', acctID);
        formData.append('xJobRequisitionID', props.data.requisitionID);
        formData.append('xJobApplicationID', props.data.applicationID);
        formData.append('sessionID', sessionID);


        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        

        let url;

        if(props.data.status == 'user_applicant_onboarding')
        {
           url = baseURL+'ghanaverified/';
        }
        else
        {
            url = baseURL+'internal_merchantAcct_argsjqApp'
        }
        fetch(url, requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);
            
            props.closeModal(false);

        })
        .catch(error => {
            console.error(error);
        })
    }

    function xinitialEmployeeFirstName_confirm(event) {
        if (event[0] == true) {
            setEmployeeFirstName_checked(event[0]);
            setEmployeeFirstName_checked_data(event[1]);
        } else if (event[0] == false) {
            setEmployeeFirstName_checked(event[0]);
            setEmployeeFirstName_checked_data(null);
        }
    }
    
    function xinitialEmployeeMiddleName_confirm(event) {
        if (event[0] == true) {
            setEmployeeMiddleName_checked(event[0]);
            setEmployeeMiddleName_checked_data(event[1]);
        } else if (event[0] == false) {
            setEmployeeMiddleName_checked(event[0]);
            setEmployeeMiddleName_checked_data(null);
        }
    }
    
    function xinitialEmployeeLastName_confirm(event) {
        if (event[0] == true) {
            setEmployeeLastName_checked(event[0]);
            setEmployeeLastName_checked_data(event[1]);
        } else if (event[0] == false) {
            setEmployeeLastName_checked(event[0]);
            setEmployeeLastName_checked_data(null);
        }
    }
    
    function xinitialEmployeePhoneNumber_confirm(event) {
        if (event[0] == true) {
            setEmployeePhoneNumber_checked(event[0]);
            setEmployeePhoneNumber_checked_data(event[1]);
        } else if (event[0] == false) {
            setEmployeePhoneNumber_checked(event[0]);
            setEmployeePhoneNumber_checked_data(null);
        }
    }
    
    function xinitialEmployeeEmail_confirm(event) {
        if (event[0] == true) {
            setEmployeeEmail_checked(event[0]);
            setEmployeeEmail_checked_data(event[1]);
        } else if (event[0] == false) {
            setEmployeeEmail_checked(event[0]);
            setEmployeeEmail_checked_data(null);
        }
    }
    
    function xinitialEmployeeAddressNumber_confirm(event) {
        if (event[0] == true) {
            setEmployeeAddressNumber_checked(event[0]);
            setEmployeeAddressNumber_checked_data(event[1]);
        } else if (event[0] == false) {
            setEmployeeAddressNumber_checked(event[0]);
            setEmployeeAddressNumber_checked_data(null);
        }
    }
    
    function xinitialEmployeeStreetName_confirm(event) {
        if (event[0] == true) {
            setEmployeeStreetName_checked(event[0]);
            setEmployeeStreetName_checked_data(event[1]);
        } else if (event[0] == false) {
            setEmployeeStreetName_checked(event[0]);
            setEmployeeStreetName_checked_data(null);
        }
    }
    
    function xinitialEmployeeCity_confirm(event) {
        if (event[0] == true) {
            setEmployeeCity_checked(event[0]);
            setEmployeeCity_checked_data(event[1]);
        } else if (event[0] == false) {
            setEmployeeCity_checked(event[0]);
            setEmployeeCity_checked_data(null);
        }
    }
    
    function xinitialEmployeeCityDistrict_confirm(event) {
        if (event[0] == true) {
            setEmployeeCityDistrict_checked(event[0]);
            setEmployeeCityDistrict_checked_data(event[1]);
        } else if (event[0] == false) {
            setEmployeeCityDistrict_checked(event[0]);
            setEmployeeCityDistrict_checked_data(null);
        }
    }
    
    function xinitialEmployeeCountryRegion_confirm(event) {
        if (event[0] == true) {
            setEmployeeCountryRegion_checked(event[0]);
            setEmployeeCountryRegion_checked_data(event[1]);
        } else if (event[0] == false) {
            setEmployeeCountryRegion_checked(event[0]);
            setEmployeeCountryRegion_checked_data(null);
        }
    }
    
    function xinitialEmployeeCountry_confirm(event) {
        if (event[0] == true) {
            setEmployeeCountry_checked(event[0]);
            setEmployeeCountry_checked_data(event[1]);
        } else if (event[0] == false) {
            setEmployeeCountry_checked(event[0]);
            setEmployeeCountry_checked_data(null);
        }
    }
    
    function xinitialEmployeeDigitalAddressID_confirm(event) {
        if (event[0] == true) {
            setEmployeeDigitalAddressID_checked(event[0]);
            setEmployeeDigitalAddressID_checked_data(event[1]);
        } else if (event[0] == false) {
            setEmployeeDigitalAddressID_checked(event[0]);
            setEmployeeDigitalAddressID_checked_data(null);
        }
    }

    function xinitialEmployeeUsername_confirm(event) {
        if (event[0] == true) {
            setEmployeeUsername_checked(event[0]);
            setEmployeeUsername_checked_data(event[1]);
        } else if (event[0] == false) {
            setEmployeeUsername_checked(event[0]);
            setEmployeeUsername_checked_data(null);
        }
    }
    function xinitialEmployeePassword_confirm(event)
    {
        if(event[0] == true)
        {
            setEmployeePassword_checked(event[0]);
            setEmployeePassword_checked_data(event[1]);
        }
        else if(event[0] == false)
        {
            setEmployeePassword_checked(event[0]);
            setEmployeePassword_checked_data(null);
        }

    }

    function xinitialEmployeeHireDate_confirm(event) {
        if (event[0] == true) {
            setEmployeeHireDate_checked(event[0]);
            setEmployeeHireDate_checked_data(event[1]);
        } else if (event[0] == false) {
            setEmployeeHireDate_checked(event[0]);
            setEmployeeHireDate_checked_data(null);
        }
    }
    
    function xinitialEmployeeUpload_ghanaID_confirm(event) {
        if (event[0] == true) {
            setEmployeeUpload_ghanaID_checked(event[0]);
            setEmployeeUpload_ghanaID_checked_data(event[1]);
        } else if (event[0] == false) {
            setEmployeeUpload_ghanaID_checked(event[0]);
            setEmployeeUpload_ghanaID_checked_data(null);
        }
    }
    
    function xinitialEmployeeUpload_verifyMTNMomo_confirm(event) {
        if (event[0] == true) {
            setEmployeeUpload_verifyMTNMomo_checked(event[0]);
            setEmployeeUpload_verifyMTNMomo_checked_data(event[1]);
        } else if (event[0] == false) {
            setEmployeeUpload_verifyMTNMomo_checked(event[0]);
            setEmployeeUpload_verifyMTNMomo_checked_data(null);
        }
    }
    
    function xinitialEmployeeUpload_utilityBill_confirm(event) {
        if (event[0] == true) {
            setEmployeeUpload_utilityBill_checked(event[0]);
            setEmployeeUpload_utilityBill_checked_data(event[1]);
        } else if (event[0] == false) {
            setEmployeeUpload_utilityBill_checked(event[0]);
            setEmployeeUpload_utilityBill_checked_data(null);
        }
    }
    
    function xinitialOffer_amount_confirm(event) {
        if (event[0] == true) {
            setOffer_amount_checked(event[0]);
            setOffer_amount_checked_data(event[1]);
        } else if (event[0] == false) {
            setOffer_amount_checked(event[0]);
            setOffer_amount_checked_data(null);
        }
    }
    
    function xinitialOffer_document_confirm(event) {
        if (event[0] == true) {
            setOffer_document_checked(event[0]);
            setOffer_document_checked_data(event[1]);
        } else if (event[0] == false) {
            setOffer_document_checked(event[0]);
            setOffer_document_checked_data(null);
        }
    }

    function xinitialOnboardingStatus(event) {
        if (event[0] == true) {
            setOnboarding_staus_checked(event[0]);
            setOnboardingDateLogged_checked_data(event[1]);
        } else if (event[0] == false) {
            setOnboarding_staus_checked(event[0]);
            setOnboardingDateLogged_checked_data(null);
        }
    }


    function handleFileChange_ghanaID(event) {


        const file = event.target.files ? event.target.files[0] : null;
        setEmployeeUpload_ghanaID(file);
        //setFileName(file ? file.name : '');
    }
    function handleFileChange_utilityBill(event) {


        const file = event.target.files ? event.target.files[0] : null;
        setEmployeeUpload_utilityBill(file);
        //setFileName(file ? file.name : '');
    }

    function viewGhanaIDModalHandler(event) {


        //setApplicationID(event[1]);
        setEmployeeUpload_ghanaID(event[2]);
        setViewGhanaIDModal(event[0]);

    }

    function viewUtilityBillModalHandler(event) {


        //setApplicationID(event[1]);
        setEmployeeUpload_utilityBill(event[2]);
        setViewUtilityBillModal(event[0]);

    }

    function closeModalHandler() {

        setViewApplicatioDetails([]);
        props.closeModal(false);
    }
    // alert("in Onboarding_Details 7");
    // alert(baseURL);
    // alert(props.data.status);


    return (
        <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
        <IonHeader className='grid_header'>
            <IonGrid >

                    <IonRow>
                        <IonCol> ONBOARDING</IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol> {props.data.requisitionName} </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol> Application ID</IonCol>
                        <IonCol> Applicant Name</IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol> {props.data.applicationID} </IonCol>
                        <IonCol> {props.data.applicant_first_name + " "+props.data.applicant_last_name} </IonCol>
                    </IonRow>
            </IonGrid>
        </IonHeader>
        <IonContent className='grid_content'>

            {viewApplicationDetails.map((detailData) =>   {
            return (
            <IonGrid >
                <IonRow >
                    <IonCol size='4' >Category</IonCol>
                    <IonCol size='4'>Value</IonCol>
                    <IonCol size='4' >Action</IonCol>
                </IonRow>
                <IonRow>
                    <IonCol size='4'>
                        <IonText>First Name</IonText>
                    </IonCol>
                    <IonCol size='4'>
                        {row_1 == true && <IonInput type='text' value={employeeFirstName} onIonChange={(e) => setEmployeeFirstName(e.detail.value)}></IonInput>}
                        {row_1 == false && <IonText>{employeeFirstName}</IonText>}
                    </IonCol>
                    {row_1 == false && <IonCol size='3'>
                        <IonButton className='small_button' onClick={() => setRow_1(true)}>Update</IonButton>
                    </IonCol>}
                    {row_1 == true && <IonCol size='3'>
                        <IonButton className='small_button' onClick={() => setRow_1(false)}>Confirm</IonButton>
                    </IonCol>}
                    {row_1 == false && <IonCol size='1'>
                        <IonCheckbox checked={employeeFirstName_checked} onIonChange={(e) => xinitialEmployeeFirstName_confirm([e.detail.checked, employeeFirstName])} />
                    </IonCol>}
                </IonRow>

                <IonRow>
                    <IonCol size='4'>
                        <IonText>Middle Name</IonText>
                    </IonCol>
                    <IonCol size='4'>
                        {row_2 == true && <IonInput type='text' value={employeeMiddleName} onIonChange={(e) => setEmployeeMiddleName(e.detail.value)}></IonInput>}
                        {row_2 == false && <IonText>{employeeMiddleName}</IonText>}
                    </IonCol>
                    {row_2 == false && <IonCol size='3'>
                        <IonButton className='small_button' onClick={() => setRow_2(true)}>Update</IonButton>
                    </IonCol>}
                    {row_2 == true && <IonCol size='3'>
                        <IonButton className='small_button' onClick={() => setRow_2(false)}>Confirm</IonButton>
                    </IonCol>}
                    {row_2 == false && <IonCol size='1'>
                        <IonCheckbox checked={employeeMiddleName_checked} onIonChange={(e) => xinitialEmployeeMiddleName_confirm([e.detail.checked, employeeMiddleName])} />
                    </IonCol>}
                </IonRow>

                <IonRow>
                    <IonCol size='4'>
                        <IonText>Last Name</IonText>
                    </IonCol>
                    <IonCol size='4'>
                        {row_3 == true && <IonInput type='text' value={employeeLastName} onIonChange={(e) => setEmployeeLastName(e.detail.value)}></IonInput>}
                        {row_3 == false && <IonText>{employeeLastName}</IonText>}
                    </IonCol>
                    {row_3 == false && <IonCol size='3'>
                        <IonButton className='small_button' onClick={() => setRow_3(true)}>Update</IonButton>
                    </IonCol>}
                    {row_3 == true && <IonCol size='3'>
                        <IonButton className='small_button' onClick={() => setRow_3(false)}>Confirm</IonButton>
                    </IonCol>}
                    {row_3 == false && <IonCol size='1'>
                        <IonCheckbox checked={employeeLastName_checked} onIonChange={(e) => xinitialEmployeeLastName_confirm([e.detail.checked, employeeLastName])} />
                    </IonCol>}
                </IonRow>

                <IonRow>
                    <IonCol size='4'>
                        <IonText>Mobile Number</IonText>
                    </IonCol>
                    <IonCol size='4'>
                        {row_4 == true && <IonInput type='text' value={employeePhoneNumber} onIonChange={(e) => setEmployeePhoneNumber(e.detail.value)}></IonInput>}
                        {row_4 == false && <IonText>{employeePhoneNumber}</IonText>}
                    </IonCol>
                    {row_4 == false && <IonCol size='3'>
                        <IonButton className='small_button' onClick={() => setRow_4(true)}>Update</IonButton>
                    </IonCol>}
                    {row_4 == true && <IonCol size='3'>
                        <IonButton className='small_button' onClick={() => setRow_4(false)}>Confirm</IonButton>
                    </IonCol>}
                    {row_4 == false && <IonCol size='1'>
                        <IonCheckbox checked={employeePhoneNumber_checked} onIonChange={(e) => xinitialEmployeePhoneNumber_confirm([e.detail.checked, employeePhoneNumber])} />
                    </IonCol>}
                </IonRow>

                <IonRow>
                    <IonCol size='4'>
                        <IonText>Email</IonText>
                    </IonCol>
                    <IonCol size='4'>
                        {row_5 == true && <IonInput type='text' value={employeeEmail} onIonChange={(e) => setEmployeeEmail(e.detail.value)}></IonInput>}
                        {row_5 == false && <IonText>{employeeEmail}</IonText>}
                    </IonCol>
                    {row_5 == false && <IonCol size='3'>
                        <IonButton className='small_button' onClick={() => setRow_5(true)}>Update</IonButton>
                    </IonCol>}
                    {row_5 == true && <IonCol size='3'>
                        <IonButton className='small_button' onClick={() => setRow_5(false)}>Confirm</IonButton>
                    </IonCol>}
                    {row_5 == false && <IonCol size='1'>
                        <IonCheckbox checked={employeeEmail_checked} onIonChange={(e) => xinitialEmployeeEmail_confirm([e.detail.checked, employeeEmail])} />
                    </IonCol>}
                </IonRow>

                <IonRow>
                    <IonCol size='4'>
                        <IonText>Address Number</IonText>
                    </IonCol>
                    <IonCol size='4'>
                        {row_6 == true && <IonInput type='text' value={employeeAddressNumber} onIonChange={(e) => setEmployeeAddressNumber(e.detail.value)}></IonInput>}
                        {row_6 == false && <IonText>{employeeAddressNumber}</IonText>}
                    </IonCol>
                    {row_6 == false && <IonCol size='3'>
                        <IonButton className='small_button' onClick={() => setRow_6(true)}>Update</IonButton>
                    </IonCol>}
                    {row_6 == true && <IonCol size='3'>
                        <IonButton className='small_button' onClick={() => setRow_6(false)}>Confirm</IonButton>
                    </IonCol>}
                    {row_6 == false && <IonCol size='1'>
                        <IonCheckbox checked={employeeAddressNumber_checked} onIonChange={(e) => xinitialEmployeeAddressNumber_confirm([e.detail.checked, employeeAddressNumber])} />
                    </IonCol>}
                </IonRow>

                <IonRow>
                    <IonCol size='4'>
                        <IonText>Street Name</IonText>
                    </IonCol>
                    <IonCol size='4'>
                        {row_7 == true && <IonInput type='text' value={employeeStreetName} onIonChange={(e) => setEmployeeStreetName(e.detail.value)}></IonInput>}
                        {row_7 == false && <IonText>{employeeStreetName}</IonText>}
                    </IonCol>
                    {row_7 == false && <IonCol size='3'>
                        <IonButton className='small_button' onClick={() => setRow_7(true)}>Update</IonButton>
                    </IonCol>}
                    {row_7 == true && <IonCol size='3'>
                        <IonButton className='small_button' onClick={() => setRow_7(false)}>Confirm</IonButton>
                    </IonCol>}
                    {row_7 == false && <IonCol size='1'>
                        <IonCheckbox checked={employeeStreetName_checked} onIonChange={(e) => xinitialEmployeeStreetName_confirm([e.detail.checked, employeeStreetName])} />
                    </IonCol>}
                </IonRow>

                <IonRow>
                    <IonCol size='4'>
                        <IonText>City</IonText>
                    </IonCol>
                    <IonCol size='4'>
                        {row_8 == true && <IonInput type='text' value={employeeCity} onIonChange={(e) => setEmployeeCity(e.detail.value)}></IonInput>}
                        {row_8 == false && <IonText>{employeeCity}</IonText>}
                    </IonCol>
                    {row_8 == false && <IonCol size='3'>
                        <IonButton className='small_button' onClick={() => setRow_8(true)}>Update</IonButton>
                    </IonCol>}
                    {row_8 == true && <IonCol size='3'>
                        <IonButton className='small_button' onClick={() => setRow_8(false)}>Confirm</IonButton>
                    </IonCol>}
                    {row_8 == false && <IonCol size='1'>
                        <IonCheckbox checked={employeeCity_checked} onIonChange={(e) => xinitialEmployeeCity_confirm([e.detail.checked, employeeCity])} />
                    </IonCol>}
                </IonRow>

                <IonRow>
                    <IonCol size='4'>
                        <IonText>City District</IonText>
                    </IonCol>
                    <IonCol size='4'>
                        {row_9 == true && <IonInput type='text' value={employeeCityDistrict} onIonChange={(e) => setEmployeeCityDistrict(e.detail.value)}></IonInput>}
                        {row_9 == false && <IonText>{employeeCityDistrict}</IonText>}
                    </IonCol>
                    {row_9 == false && <IonCol size='3'>
                        <IonButton className='small_button' onClick={() => setRow_9(true)}>Update</IonButton>
                    </IonCol>}
                    {row_9 == true && <IonCol size='3'>
                        <IonButton className='small_button' onClick={() => setRow_9(false)}>Confirm</IonButton>
                    </IonCol>}
                    {row_9 == false && <IonCol size='1'>
                        <IonCheckbox checked={employeeCityDistrict_checked} onIonChange={(e) => xinitialEmployeeCityDistrict_confirm([e.detail.checked, employeeCityDistrict])} />
                    </IonCol>}
                </IonRow>

                <IonRow>
                    <IonCol size='4'>
                        <IonText>Country Region</IonText>
                    </IonCol>
                    <IonCol size='4'>
                        {row_10 == true && <IonInput type='text' value={employeeCountryRegion} onIonChange={(e) => setEmployeeCountryRegion(e.detail.value)}></IonInput>}
                        {row_10 == false && <IonText>{employeeCountryRegion}</IonText>}
                    </IonCol>
                    {row_10 == false && <IonCol size='3'>
                        <IonButton className='small_button' onClick={() => setRow_10(true)}>Update</IonButton>
                    </IonCol>}
                    {row_10 == true && <IonCol size='3'>
                        <IonButton className='small_button' onClick={() => setRow_10(false)}>Confirm</IonButton>
                    </IonCol>}
                    {row_10 == false && <IonCol size='1'>
                        <IonCheckbox checked={employeeCountryRegion_checked} onIonChange={(e) => xinitialEmployeeCountryRegion_confirm([e.detail.checked, employeeCountryRegion])} />
                    </IonCol>}
                </IonRow>
                <IonRow>
                    <IonCol size='4'>
                        <IonText>Country</IonText>
                    </IonCol>
                    <IonCol size='4'>
                        {row_11 == true && <IonInput type='text' value={employeeCountry} onIonChange={(e) => setEmployeeCountry(e.detail.value)}></IonInput>}
                        {row_11 == false && <IonText>{employeeCountry}</IonText>}
                    </IonCol>
                    {row_11 == false && <IonCol size='3'>
                        <IonButton className='small_button' onClick={() => setRow_11(true)}>Update</IonButton>
                    </IonCol>}
                    {row_11 == true && <IonCol size='3'>
                        <IonButton className='small_button' onClick={() => setRow_11(false)}>Confirm</IonButton>
                    </IonCol>}
                    {row_11 == false && <IonCol size='1'>
                        <IonCheckbox checked={employeeCountry_checked} onIonChange={(e) => xinitialEmployeeCountry_confirm([e.detail.checked, employeeCountry])} />
                    </IonCol>}
                </IonRow>

                <IonRow>
                    <IonCol size='4'>
                        <IonText>Digital Address</IonText>
                    </IonCol>
                    <IonCol size='4'>
                        {row_12 == true && <IonInput type='text' value={employeeCountry} onIonChange={(e) => setEmployeeCountry(e.detail.value)}></IonInput>}
                        {row_12 == false && <IonText>{employeeDigitalAddressID}</IonText>}
                    </IonCol>
                    {row_12 == false && <IonCol size='3'>
                        <IonButton className='small_button' onClick={() => setRow_12(true)}>Update</IonButton>
                    </IonCol>}
                    {row_12 == true && <IonCol size='3'>
                        <IonButton className='small_button' onClick={() => setRow_12(false)}>Confirm</IonButton>
                    </IonCol>}
                    {row_12 == false && <IonCol size='1'>
                        <IonCheckbox checked={employeeDigitalAddressID_checked} onIonChange={(e) => xinitialEmployeeDigitalAddressID_confirm([e.detail.checked, employeeDigitalAddressID])} />
                    </IonCol>}
                </IonRow>

                <IonRow>
                    <IonCol size='4'>
                        <IonText>Enter Username</IonText>
                    </IonCol>
                    <IonCol size='4'>
                        {row_13 == true && <IonInput type='text' placeholder='Enter preferred Username' onIonChange={(e) => setEmployeeUsername(e.detail.value)}></IonInput>}
                        {row_13 == false && <IonText>{employeeUsername}</IonText>}
                    </IonCol>
                    {row_13 == false && <IonCol size='3'>
                        <IonButton className='small_button' onClick={() => setRow_13(true)}>Update</IonButton>
                    </IonCol>}
                    {row_13 == true && <IonCol size='3'>
                        <IonButton className='small_button' onClick={() => setRow_13(false)}>Confirm</IonButton>
                    </IonCol>}
                    {row_13 == false && <IonCol size='1'>
                        <IonCheckbox checked={employeeUsername_checked} onIonChange={(e) => xinitialEmployeeUsername_confirm([e.detail.checked, employeeUsername])} />
                    </IonCol>}
                </IonRow>

                <IonRow>
                    <IonCol size='4'>
                        <IonText>Password</IonText>
                    </IonCol>
                    <IonCol size='4'>
                        {row_14 == true && <IonInput type='text' placeholder='Enter preferred password' onIonChange={(e) => setEmployeePassword(e.detail.value)}></IonInput>}
                        {row_14 == false && <IonText>{employeePassword}</IonText>}
                    </IonCol>
                    {row_14 == false && <IonCol size='3'>
                        <IonButton className='small_button' onClick={() => setRow_14(true)}>Update</IonButton>
                    </IonCol>}
                    {row_14 == true && <IonCol size='3'>
                        <IonButton className='small_button' onClick={() => setRow_14(false)}>Confirm</IonButton>
                    </IonCol>}
                    {row_14 == false && <IonCol size='1'>
                        <IonCheckbox checked={employeePassword_checked} onIonChange={(e) => xinitialEmployeePassword_confirm([e.detail.checked, employeePassword])} />
                    </IonCol>}
                </IonRow>

                <IonRow>
                    <IonCol>
                        <IonText>Ghana ID</IonText>
                    </IonCol>
                    <IonCol>
                        {row_15 == true && 
                            <input
                                type="file"
                                accept=".doc,.docx,.pdf,.jpeg,.jpg,.png,.odt"
                                onChange={(event) => handleFileChange_ghanaID(event)}
                            />}
                        {row_15 == false && <IonButton className='gridResultColumnButton' onClick={() => viewGhanaIDModalHandler([true, detailData.application_id, detailData.upload_ghana_id])}> View </IonButton>}
                    </IonCol>
                    {row_15 == false && <IonCol>
                        <IonButton className='small_button' onClick={() => setRow_15(true)}>Update</IonButton>
                    </IonCol>}
                    {row_15 == true && <IonCol size='3'>
                        <IonButton className='small_button' onClick={() => setRow_15(false)}>Confirm</IonButton>
                    </IonCol>}
                    {row_15 == false && <IonCol>
                        <IonCheckbox checked={employeeUpload_ghanaID_checked} onIonChange={(e) => xinitialEmployeeUpload_ghanaID_confirm([e.detail.checked, employeeUpload_ghanaID])} />
                    </IonCol>}
                </IonRow>

                <IonRow>
                    <IonCol size='4'>
                        <IonText>Utility Bill</IonText>
                    </IonCol>
                    <IonCol>
                        {row_16 == true && 
                            <input
                                type="file"
                                accept=".doc,.docx,.pdf,.jpeg,.jpg,.png,.odt"
                                onChange={(event) => handleFileChange_utilityBill(event)}
                            />}
                        {row_16 == false && <IonButton className='gridResultColumnButton' onClick={() => viewUtilityBillModalHandler([true, detailData.application_id, detailData.upload_utility_bill])}> View </IonButton>}
                    </IonCol>
                    {row_16 == false && <IonCol>
                        <IonButton className='small_button' onClick={() => setRow_16(true)}>Update</IonButton>
                    </IonCol>}
                    {row_16 == true && <IonCol size='3'>
                        <IonButton className='small_button' onClick={() => setRow_16(false)}>Confirm</IonButton>
                    </IonCol>}
                    {row_16 == false && <IonCol>
                        <IonCheckbox checked={employeeUpload_utilityBill_checked} onIonChange={(e) => xinitialEmployeeUpload_utilityBill_confirm([e.detail.checked, employeeUpload_utilityBill])} />
                    </IonCol>}
                </IonRow>
                <IonRow >
                    <IonCol size='6'>                        
                        <IonLabel htmlFor="mmProvider">Onboading Status </IonLabel>
                    </IonCol>
                    <IonCol size='6'>
                        <select name="onboarding_status" id='onboarding_status' value={onboarding_staus} onChange={(e) => setOnboarding_staus(e.target.value)}>
                            <option value='pending'>Pending</option>
                            <option value='completed'>Completed</option>
                        </select>
                    </IonCol>
                </IonRow>
                {(props.data.status == 'user_applicant_onboarding' && onboarding_staus_initial != 'completed') && <IonRow>
                    <IonCol>
                        <IonButton onClick={() => updateOnboardingStatus()}>Save</IonButton>
                    </IonCol>
                </IonRow>}
                {(props.data.status == 'user_applicant_onboarding' && onboarding_staus_initial == 'completed') && <IonRow>
                    <IonCol>
                        <IonText >PENDING REVIEW</IonText>
                    </IonCol>
                </IonRow>}
                </IonGrid>
                    )
                }
            )}
                {props.data.status != 'user_applicant_onboarding' && 
                    <IonGrid className='gridText_admin_onboarding'>
                        <IonRow>
                            <IonCol size='4'>                        
                                <IonLabel htmlFor="mmProvider"> Hire Date </IonLabel>
                            </IonCol>
                            <IonCol size='4'>
                            {row_17 == true && <IonInput type='date' value={employeeHireDate.toISOString().substr(0, 10)} onIonChange={(e)=> setEmployeeHireDate(new Date(e.target.value))}></IonInput>}
                            {row_17 == false && <IonText>{employeeHireDate.toISOString().substr(0, 10)}</IonText>}
                            </IonCol>
                            {row_17 == false && <IonCol size='4'>
                                <IonButton className='small_button' onClick={() => setRow_17(true)}>Update</IonButton>
                            </IonCol>}
                            {row_17 == true && <IonCol size='4'>
                                <IonButton className='small_button' onClick={() => setRow_17(false)}>Confirm</IonButton>
                            </IonCol>}
                        </IonRow>
                        <IonRow className='gridResultBody'>
                            <IonCol size='6'>                        
                                <IonLabel htmlFor="mmProvider"> Company Role </IonLabel>
                            </IonCol>
                            <IonCol size='6'>
                            {row_10 == false && 
                                    <select name="onboarding_status" id='onboarding_status' value={employeeCompanyAccessRole} onChange={(e) => setEmployeeCompanyAccessRole(e.target.value)}>
                                    <option value='manager'>Manager</option>
                                    <option value='front_desk'>Front Desk</option>
                                    <option value='cleaning_service'>Cleaning</option>
                                    <option value='individual_contributor'>Individual Contributor</option>
                                    <option value='restaurant_kitchen'>Restaurant Kitchen</option>
                                    <option value='security_guard'>Security Guard</option>
                                </select>}
                                {row_10 == true &&<IonText>{employeeCompanyAccessRole}</IonText>}
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonButton onClick={() => updateOnboardingStatus()}>Save</IonButton>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol size='6'>
                                <IonButton onClick={() => convertApplicantToEmployee()}>Convert to Employee</IonButton>
                            </IonCol>
                            <IonCol size='6'>
                                <IonButton onClick={() => recindOffer()}>Recind Offer</IonButton>
                            </IonCol>
                        </IonRow>
                    </IonGrid>}

        </IonContent>

        
        <IonFooter className='grid_footer'>
            <IonButton onClick={() => closeModalHandler(false)}>Cancel </IonButton>
        </IonFooter>

        {viewGhanaIDModal == true && <ViewInvoiceModal openModal={ viewGhanaIDModal } closeModal={() => viewGhanaIDModalHandler(false)} data={{
                                        fileLocation: employeeUpload_ghanaID, 
                                        applicationID: props.data.applicationID, 
                                        }}></ViewInvoiceModal>}

        {viewUtilityBillModal == true && <ViewInvoiceModal openModal={ viewUtilityBillModal } closeModal={() => viewUtilityBillModalHandler(false)} data={{
                                                fileLocation: employeeUpload_utilityBill, 
                                                applicationID: props.data.applicationID, 
                                                }}></ViewInvoiceModal>}
    </IonModal>) : null}
    </React.Fragment>
    )
}